import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const PyramidIllustration = ({ width = 44, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 39">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#94C9E2"
          d="M29.187 12.867L14.087 12.867 7.26 25.047 36.014 25.047z"
          transform="translate(0 .367)"
        />
        <path
          fill="#FFBF00"
          d="M22.133.348c-.123-.22-.283-.326-.444-.345-.193-.022-.39.085-.535.345l-6.392 11.404h13.764L22.133.348z"
          transform="translate(0 .367)"
        />
        <path
          fill="#FF7236"
          d="M43.19 37.763L36.7 26.24h-8.802L34.8 38.633h7.878c.553 0 .784-.384.512-.87M26.008 26.24H6.562L.113 37.744c-.269.481-.042.871.51.871h32.313L26.008 26.24z"
          transform="translate(0 .367)"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M29.171 12.867L21.636 12.867 21.636 25.047 35.998 25.047zM22.117.348c-.123-.22-.283-.326-.444-.345-.012-.001-.024.003-.036.002v11.747h6.873L22.117.348zM43.175 37.763l-6.49-11.523h-8.802l6.902 12.393h7.878c.553 0 .784-.384.512-.87M25.993 26.24L21.637 26.24 21.637 38.615 32.921 38.615z"
          transform="translate(0 .367)"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
